const PRODUCTION_API_BASE = 'https://financial-processor-prod-dafneqa8amd6gqbm.uksouth-01.azurewebsites.net/api';

function resolveApiBase(): string {
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }

  if (typeof window === 'undefined') {
    return '/api';
  }

  const hostname = window.location.hostname;
  if (hostname === 'www.financial-ai.uk' || hostname === 'green-river-05926d803.1.azurestaticapps.net') {
    return PRODUCTION_API_BASE;
  }

  return '/api';
}

export const API_BASE = resolveApiBase();
export const API_KEY = process.env.REACT_APP_API_KEY || '';